export const PromotionalImage = ({
    promotionTag,
    className,
}: {
    promotionTag?: { url: string; alt?: string }
    className?: string
}) => {
    if (!promotionTag) return <></>
    return <img alt={promotionTag.alt || ""} src={promotionTag.url} className={className || "w-15"} />
}
